import { ref } from 'vue';
import { segundosParaTentar } from './corporacaoEmPreparo.js';

/**
 * O estado da tela de espera ("o hdocs esta sendo preparado para a sua empresa"). Quem liga e o cliente de API (apiClient.js), ao ver o aviso
 * da API; quem mostra e EmpresaEmPreparo.vue, montada no App.vue. Sem Pinia: e uma bandeira so.
 */
export const emPreparo = ref(false);
export const segundosDeEspera = ref(15);

export function avisarEmPreparo(erro) {
    segundosDeEspera.value = segundosParaTentar(erro);
    emPreparo.value = true;
}
